export default __webpack_public_path__ + "static/media/personalization.17a48703.svg";